import React, { useEffect, useState } from "react";

import { Box, Stack, Typography } from "@mui/material";

const Variability_Image = ({ variabilityData }) => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    setImages([]);
    loadImages();
  }, [variabilityData]);

  const loadImages = () => {
    if (!variabilityData || variabilityData?.length === 0) {
      setImages([]);
      return;
    }

    let imageArray = [];
    for (const record of variabilityData) {
      imageArray.push(
        <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>
          {record.data.variabilityValue}
        </Typography>
      );
      const imageNames = Object.keys(record.data);
      for (const imageName of imageNames) {
        imageArray.push(
          <Box sx={{ padding: "8px" }}>
            <Typography sx={{ fontSize: "12px", fontWeight: "bold" }}>
              {imageName}
            </Typography>
            <img
              src={record.data[imageName]}
              width="100%"
              height="auto"
            />
          </Box>
        );
      }
    }

    setImages(imageArray);
  };

  if (images.length === 0) return <Typography>No images</Typography>;

  return <Stack sx={{ width: "100%" }}>{images.map((image) => image)}</Stack>;
};

export default Variability_Image;
